import { DrawerPanel } from '@dmc/ui';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useLoadCustomInvestigationDependencies } from '../useLoadCustomInvestigationDependencies';
import { CreateCustomInvestigationForm } from './components/form/CreateCustomInvestigationForm';
import { ModelName } from '@customer/store/types';

export const CreateCustomInvestigationPanel = (): ReactElement => {
  const { t } = useTranslation();

  const { isLoaded, renderKey, assets } = useLoadCustomInvestigationDependencies();

  return (
    <DrawerPanel
      isLoaded={isLoaded}
      header={t('Model.Create.Title', { modelName: ModelName.Investigation })}
    >
      <CreateCustomInvestigationForm key={renderKey} assets={assets ?? []} />
    </DrawerPanel>
  );
};

export default CreateCustomInvestigationPanel;
